'use client'
import { useNavUI } from '@/lib/navContext'

export default function SidebarTrigger() {
  const { openSidebar } = useNavUI()
  // Open via context (core, same tree) and a window event (casino, where the Sidebar lives in a
  // separate widget root that can't share this context). Both paths are idempotent.
  function open() {
    openSidebar()
    if (typeof window !== 'undefined') window.dispatchEvent(new Event('weeabets:open-sidebar'))
  }
  return (
    <button
      onClick={open}
      className="p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors md:hidden"
      aria-label="Open sidebar"
    >
      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M3 6a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
      </svg>
    </button>
  )
}
